import currencyFormatter from 'currency-formatter'

const convertCultureCurrencyPositivePatternToFormat = (currencyPositivePattern, symbol, currencyCode) => {
  let format = null

  const displayCurrencyCode = symbol === '$' && currencyCode !== 'USD'

  switch (currencyPositivePattern) {
    case 0: // $n
      if (displayCurrencyCode === true) {
        format = `${currencyCode}%s%v`
      } else {
        format = '%s%v'
      }
      break
    case 1: // n$
      if (displayCurrencyCode === true) {
        format = `%v ${currencyCode}%s`
      } else {
        format = '%v%s'
      }
      break
    case 2: // $ n
      if (displayCurrencyCode === true) {
        format = `${currencyCode}%s %v`
      } else {
        format = '%s %v'
      }
      break
    case 3: // n $
      if (displayCurrencyCode === true) {
        format = `%v ${currencyCode}%s`
      } else {
        format = '%v %s'
      }
      break
    default:
      throw new Error('convertCultureCurrencyPositivePatternToFormat does not support the currencyPositivePattern of this culture.')
  }

  return format
}

export default {
  format (value, currentCultureNumberFormat, currencyCode) {
    const currencySettings = currencyFormatter.findCurrency(currencyCode)

    const formatOptions = {
      decimal: currentCultureNumberFormat.CurrencyDecimalSeparator,
      format: convertCultureCurrencyPositivePatternToFormat(currentCultureNumberFormat.CurrencyPositivePattern, currencySettings.symbol, currencyCode), // %s is the symbol and %v is the value
      precision: currentCultureNumberFormat.CurrencyDecimalDigits,
      symbol: currencySettings.symbol,
      thousand: currentCultureNumberFormat.CurrencyGroupSeparator
    }

    return currencyFormatter.format(value, formatOptions)
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/lib/currency-formatter.js